// tslint:disable: no-magic-numbers
const TRAVEL_AGENT_CONSTANTS = {
    COOKIES: {
        TA_INFO: 'dclTravelAgentInfo',
        AGENCY_ID: 'AgencyId',
        CONVERSATION_UUID: 'Conversation_UUID',
        TOKEN: 'pep_oauth_token',
        TOKEN_EXPIRATION: 'pep_oauth_token_expiration',
        TOKEN_START_TIME: 'pep_oauth_token_start_time',
        TOKEN_REFRESH: 'pep_oauth_refresh_token',
        TOKEN_REFRESH_PP: 'pep_oauth_refresh_token_pp',
        SESSION_TTL : 'Travel-Agent-Session-Time',
        SESSION_GUID: 'TA-Session-Guid',
        TICKET_DATA : 'TICKET_DATA_jar',
        TA_SWID : 'GuestSwid',
        TA_AUTH: 'Travel-Agent-Authorization',
        SWID: 'SWID',
        GUEST_INFO: 'guestInfo_jar',
        JWT_TOKEN: 'pep_jwt_token',
        REMEMBER_ME: 'rememberme',
        CART_ID_MAPPING: 'cartIdMapping',
        SESSION_TIMEOUT: 'SESSION_TIMEOUT',
        PHPSESSID: 'PHPSESSID',
        COOKIE_OPTIONS: {
            path: '/',
            domain: document.domain,
            secondLevelDomain: document.domain.split('.').slice(-2).join('.'),
            thirdLevelDomain: document.domain.split('.').slice(-3).join('.'),
            sameSite: <'Lax' | 'None' | 'Strict'> 'Lax'
        },
        LOCALE_COOKIE: {
            cookieName: 'localeCookie_jar',
            expireDays: 7,
            precedence: 0,
            version: '2',
            defaultCurrency: 'USD',
            currency: {
                USD: {
                    contentLocale: 'en',
                    preferredRegion: 'en'
                },
                GBP: {
                    contentLocale: 'en',
                    preferredRegion: 'en_GB'
                },
                EUR: {
                    contentLocale: 'en',
                    preferredRegion: 'en_EU'
                }
            }
        }
    },
    SESSION_MIN: 20,
    SESSION_HOUR_SEC: 3600,
    DEFAULT_DAY_EXPIRATION_MIN: 1440,
    AFFILIATION_LABEL: 'Affiliation Number',
    STORAGE: {
        RECENT_RESERVATIONS: 'taRecentReservations',
        ACTIVE_SESSION : 'taSession',
        DTA_REFERRER: 'dtaReferrer',
        GUEST_CASTAWAY_INFO: 'taGuestCastawayInfo',
        ADRUM_CLIENTINFO: 'ADRUM_CLIENTINFO'
    },
    HEADERS: {
        AUTHORIZATION: 'Authorization'
    },
    ENDPOINTS: {
        AGENCY_TOKEN: 'auth-token',
        AGENCY_LOOKUP: 'dcl-session-mgr-svc/agencies/lookup',
        AGENCY_PASSPORT: 'dcl-session-mgr-svc/agencies/passport',
        AGENCY_LOGOUT: 'dcl-session-mgr-svc/agencies/sessions/delete',
        LOGOUT: '/travel-agent-logout/?rs=time-out'
    },
    TOKEN_PREFIX: 'BEARER',
    FILTERED_REQUESTS_TIMEOUT: 'config|en.json|authz|toggles|health-monitor|page-key',
    DEFAULT_RESERVATION_ID: '11111111'
};

export { TRAVEL_AGENT_CONSTANTS };
